import Head from "next/head";
import { ReactElement } from "react";
import { Container, Typography, Grid, List, ListItem, ListItemIcon } from "@mui/material";

import { useTranslation } from "../fe-ui/hooks/use-translation";

import MainLayout from "../ui/layouts/main";
import { AboutHero } from "../ui/components/about/AboutHero";
import { AboutList } from "../ui/components/about/AboutList";
import { AboutBlock } from "../ui/components/about/AboutBlock";
import { AboutSummary } from "../ui/components/about/AboutSummary";
import Iconify from "../fe-ui/atoms/Iconify/Iconify";
import { composeServerSideProps } from "next-composition";
import { withTranslations } from "../server/ssrprops/withTranslations";
import { withSeoSsrProps } from "../server/ssrprops/withSeoSsrProps";

const AboutUsPage = () => {
  const t = useTranslation();

  return (
    <>
      <Head>
        <title>{t("Footer_aboutSeaya")}</title>
      </Head>
      <Container maxWidth={"lg"}>
        <Typography variant="h3">{t("Footer_aboutSeaya")}</Typography>
        <AboutHero />
        <Typography variant="h2" sx={{ marginTop: 4, marginBottom: 8, textAlign: "center" }}>
          {t("Info_seaya_ecosystem")}
        </Typography>

        <AboutBlock title={t("Info_seaya_trust")} subtitle={t("Info_seaya_take_care")} icon="mdi:business-outline">
          <Typography sx={{ marginBottom: 2 }}>{t("Info_seaya_property_owner")}</Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <Iconify icon="ic:baseline-check" width={24} />
              </ListItemIcon>
              {t("Info_seaya_full_control")}
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Iconify icon="ic:baseline-check" width={24} />
              </ListItemIcon>
              {t("Info_seaya_personal_manager")}
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Iconify icon="ic:baseline-check" width={24} />
              </ListItemIcon>
              {t("Info_seaya_all_insurance")}
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Iconify icon="ic:baseline-check" width={24} />
              </ListItemIcon>
              {t("Info_seaya_bill")}
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Iconify icon="ic:baseline-check" width={24} />
              </ListItemIcon>
              {t("Info_seaya_rent")}
            </ListItem>
          </List>
        </AboutBlock>

        <AboutBlock title={t("Info_seaya_pms")} subtitle={t("Info_seaya_tool")} icon="carbon:gui-management">
          <Typography sx={{ marginBottom: 2 }}>{t("Info_seaya_allow")}</Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <Iconify icon="ic:baseline-check" width={24} />
              </ListItemIcon>
              {t("Info_seaya_lk")}
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Iconify icon="ic:baseline-check" width={24} />
              </ListItemIcon>
              {t("Info_seaya_adv")}
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Iconify icon="ic:baseline-check" width={24} />
              </ListItemIcon>
              {t("Info_seaya_report")}
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Iconify icon="ic:baseline-check" width={24} />
              </ListItemIcon>
              {t("Info_seaya_advantages")}
            </ListItem>
          </List>
        </AboutBlock>

        <AboutBlock
          title={t("Info_seaya_rent_service")}
          subtitle={t("Info_seaya_official_customer")}
          icon="material-symbols:apartment"
        >
          <Typography sx={{ marginBottom: 2 }}>{t("Info_seaya_income")}</Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <Iconify icon="ic:baseline-check" width={24} />
              </ListItemIcon>
              {t("Info_seaya_photo")}
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Iconify icon="ic:baseline-check" width={24} />
              </ListItemIcon>
              {t("Info_seaya_site")}
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <Iconify icon="ic:baseline-check" width={24} />
              </ListItemIcon>
              {t("Info_seaya_support")}
            </ListItem>
          </List>
        </AboutBlock>

        <Typography variant="h2" sx={{ marginTop: 4, marginBottom: 8, textAlign: "center" }}>
          {t("Info_seaya_more_service")}
        </Typography>

        <Grid container spacing={{ xs: 1, sm: 5 }} xs={12}>
          <Grid item xs={12} sm={6}>
            <AboutSummary title={t("Info_seaya_hotel_service")} color="success" icon="">
              <List>
                <ListItem>
                  <ListItemIcon>
                    <Iconify icon="ic:baseline-check" width={24} />
                  </ListItemIcon>
                  {t("Info_seaya_breakfast")}
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <Iconify icon="ic:baseline-check" width={24} />
                  </ListItemIcon>
                  {t("Info_seaya_concierge")}
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <Iconify icon="ic:baseline-check" width={24} />
                  </ListItemIcon>
                  {t("Info_seaya_dry_cleaning")}
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <Iconify icon="ic:baseline-check" width={24} />
                  </ListItemIcon>
                  {t("Info_seaya_repair")}
                </ListItem>
              </List>
            </AboutSummary>
          </Grid>
          <Grid item xs={12} sm={6}>
            <AboutSummary title={t("Info_seaya_ecosystem_part")} color="primary" icon="">
              <List>
                <ListItem>
                  <ListItemIcon>
                    <Iconify icon="ic:baseline-check" width={24} />
                  </ListItemIcon>
                  {t("Info_seaya_brand")}
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <Iconify icon="ic:baseline-check" width={24} />
                  </ListItemIcon>
                  {t("Info_seaya_promote")}
                </ListItem>
              </List>
            </AboutSummary>
          </Grid>
        </Grid>
        <Typography variant="h2" sx={{ marginTop: 4, marginBottom: 8, textAlign: "center" }}>
          {t("Info_seaya_values")}
        </Typography>
        <Grid container spacing={{ xs: 1, sm: 2 }} xs={12} sx={{ marginBottom: 4 }}>
          <Grid item xs={12} sm={3}>
            <AboutList title={t("Info_seaya_manufacturability")} icon="uil:technology">
              <List>
                <ListItem>{t("Info_seaya_optimize")}</ListItem>
                <ListItem>{t("Info_seaya_filters")}</ListItem>
              </List>
            </AboutList>
          </Grid>
          <Grid item xs={12} sm={3}>
            <AboutList title={t("Info_seaya_efficiency")} icon="icon-park-outline:success">
              <List>
                <ListItem>{t("Info_seaya_steps")}</ListItem>
                <ListItem>{t("Info_seaya_all_stages")}</ListItem>
              </List>
            </AboutList>
          </Grid>
          <Grid item xs={12} sm={3}>
            <AboutList title={t("Info_seaya_hospitality")} icon="fluent:guest-24-filled">
              <List>
                <ListItem>{t("Info_seaya_experience")}</ListItem>
                <ListItem>{t("Info_seaya_attention")}</ListItem>
                <ListItem>{t("Info_seaya_unforgettable")}</ListItem>
              </List>
            </AboutList>
          </Grid>
          <Grid item xs={12} sm={3}>
            <AboutList title={t("Info_seaya_safety")} icon="ant-design:safety-outlined">
              <List>
                <ListItem>{t("Info_seaya_payment")}</ListItem>
                <ListItem>{t("Info_seaya_management")}</ListItem>
              </List>
            </AboutList>
          </Grid>
        </Grid>
        {/* <Typography variant="h4" sx={{ marginTop: 4, marginBottom: 4 }}>
          {t("Info_seaya_team")}
        </Typography>
        <Grid container spacing={{ xs: 4, sm: 10 }} xs={12} sx={{ marginBottom: 10 }}>

          <Grid item xs={6} sm={2}>
            <Typography variant="h6">
              {t('Info_seaya_emin')}
            </Typography>
            <Typography sx={{ marginTop: 2 }}>
              {t('Info_seaya_owner')}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={2}>
            <Typography variant="h6">
              {t('Info_seaya_arthur')}
            </Typography>
            <Typography sx={{ marginTop: 2 }}>
              {t('Info_seaya_ceo')}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={2}>
            <Typography variant="h6">
              {t('Info_seaya_dmitry')}
            </Typography>
            <Typography sx={{ marginTop: 2 }}>
              {t('Info_seaya_product')}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={2}>
            <Typography variant="h6">
              {t('Info_seaya_jayla')}
            </Typography>
            <Typography sx={{ marginTop: 2 }}>
              {t('Info_seaya_sales')}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={2}>
            <Typography variant="h6">
              {t('Info_seaya_ida')}
            </Typography>
            <Typography sx={{ marginTop: 2 }}>
              {t('Info_seaya_pr')}
            </Typography>
          </Grid> 
        </Grid> */}
      </Container>
    </>
  );
};

const AboutUsPageWrapper = () => {
  return <AboutUsPage />;
};

export default AboutUsPageWrapper;

AboutUsPageWrapper.getLayout = (page: ReactElement) => <MainLayout> {page} </MainLayout>;

export const getServerSideProps = composeServerSideProps({
  use: [withTranslations, withSeoSsrProps],
});
